import React, { useState } from 'react';
import { Button, Col, message, Modal, Row, Typography, Upload } from 'antd';
import { DeleteFilled, DownloadOutlined, InboxOutlined } from '@ant-design/icons';
import { URL_API } from '@configs/index';
import { showError } from '@components/notification';
import { downloadBlobFile, uploadBlobFile } from '@utils/utils';

const SimImportModal = ({ visible, onCancel, onSuccess }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [templateLoading, setTemplateLoading] = useState(false);

  const closeModal = () => {
    setFile(null);
    onCancel();
  };

  const handleDownloadTemplate = async () => {
    try {
      setTemplateLoading(true);
      await downloadBlobFile(
        `${URL_API}/api/sim-cards/export-template`,
        'File mẫu import SIM.xlsx',
        null,
        'POST'
      );
    } catch (error) {
      showError('Không thể tải file mẫu import SIM.');
    } finally {
      setTemplateLoading(false);
    }
  };

  const handleImport = async () => {
    if (!file) {
      message.warning('Vui lòng chọn file Excel trước khi nhập.');
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      await uploadBlobFile(`${URL_API}/api/sim-cards/import`, 'Kết quả import SIM.xlsx', formData);
      setFile(null);
      onSuccess();
    } catch (error) {
      showError('Không thể import danh sách SIM.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Nhập dữ liệu SIM từ file Excel"
      open={visible}
      onCancel={closeModal}
      footer={
        <Button type="primary" loading={loading} onClick={handleImport}>
          Nhập dữ liệu
        </Button>
      }>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Button
            block
            type="link"
            icon={<DownloadOutlined />}
            loading={templateLoading}
            onClick={handleDownloadTemplate}>
            Tải về file mẫu
          </Button>
        </Col>
        <Col span={24}>
          {!file ? (
            <Upload.Dragger
              accept=".xlsx"
              maxCount={1}
              showUploadList={false}
              beforeUpload={(selectedFile) => {
                setFile(selectedFile);
                return false;
              }}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Nhấn hoặc thả file vào đây để tải lên</p>
              <p className="ant-upload-hint">Chỉ hỗ trợ file Excel định dạng .xlsx</p>
            </Upload.Dragger>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: 16 }}>
              <Typography.Text strong>{file.name}</Typography.Text>
              <Button
                type="text"
                icon={<DeleteFilled style={{ color: '#0051A9' }} />}
                onClick={() => setFile(null)}
              />
            </div>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

export default SimImportModal;
